import React, { FC } from 'react';
import './AppHeader.scss';
import { FeatureButtons } from './views/FeatureButtons';
import { ModuleButtons } from './views/ModuleButtons';
import { NavHeading } from './views/NavHeading';

type IAppHeaderProps = {};

export const AppHeader: FC<IAppHeaderProps> = function (props) {
    return (
        <>
            <div className={'appHeader appHeader--bottom-line'}>
                <FeatureButtons />
                <NavHeading />
                <ModuleButtons />
            </div>
            <div className={'appHeader-spacer'}></div>
        </>
    );
};
